//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    option: {
      type: Object,
      default: () => {},
    },
  },
}
